'use strict';

angular.module('dealerware.web.data').factory('RoundValues', function() {
  const denominator = 16;

  function percentage(decimal, resolution, rounder) {
    return rounder(decimal * resolution) / resolution;
  }

  function fuelPercentage(fuel, capacity, isConnected) {
    // Convert fuel level to nearest 16th
    const fuelDecimal = fuel / capacity;
    const rounder = isConnected ? Math.ceil : Math.round;

    return percentage(fuelDecimal, denominator, rounder) * 100;
  }

  return {
    fuelPercentage,
    percentage,
  };
});
